import { render, staticRenderFns } from "./EditPhoneNumber.vue?vue&type=template&id=84b2df72"
import script from "./EditPhoneNumber.vue?vue&type=script&lang=js"
export * from "./EditPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports